import React, { useState, useCallback, useEffect } from 'react';

import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";


import { BrComerceApiService } from "../../../../../services/BrComerceApiService";
import store from "../../../../../store/store";
import Loading from "../../../../home/components/Loading";
import Container from "../../../components/Container";

import { AiOutlineCheck } from "react-icons/ai";
import { BsExclamation } from "react-icons/bs";

import styles from "./createRange.module.scss";
import MessageModal from '../../../../../components/MessageModal';

import { MdOutlineError } from "react-icons/md";
import { FaCheckCircle } from "react-icons/fa";
import Select from "react-select";

import { selectStyle, typesOptions, ufsOptions } from '..';


const CreateZipcodeRange = () => {
  const { auth } = store.getState();
  const { user } = auth;

  const api = new BrComerceApiService();
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [uf, setUf] = useState();
  const [buttonStyle, setButtonStyle] = useState({ cursor: 'not-allowed' })
  const [openSuccessModal, setOpenSuccessModal] = useState(false)
  const [openErrorModal, setOpenErrorModal] = useState(false)
  const [modalMessage, setModalMessage] = useState("")
  const [modalTitle, setModalTitle] = useState("")
  const [selectedType, setSelectedType] = useState({ label: "Super Expresso", value: 1 });
  const [sla, setSla] = useState("");
  const [slaError, setSlaError] = useState(""); // <-- NOVO
  const [rateUf, setRateUf] = useState({ label: "Selecione a UF", value: "" });
  const [rateUfError, setRateUfError] = useState(""); // <-- NOVO
  const [originUf, setOriginUf] = useState({
    label: "Selecione a UF de origem",
    value: ""
  },);
  const [destinationUf, setDestinationUf] = useState({
    label: "Selecione a UF de destino",
    value: ""
  },);

  const useZipCode = (initialState = "vazio") => {
    const [zipCodeOK, setZipCodeOK] = useState(initialState);
    const [zipCodeError, setZipCodeError] = useState("");
    const [zipCode, setZipCode] = useState("");
    const [zipCodeValidated, setZipCodeValidated] = useState(false);

    const handleValidationZipCode = useCallback((value) => {
      if (value.length === 0) {
        setZipCodeOK("notOk");
        setZipCodeError("Preenchimento obrigatório");
        setZipCodeValidated(false);
      } else if (value.length < 9) {
        setZipCodeOK("notOk");
        setZipCodeError("Preenchimento incorreto");
        setZipCodeValidated(false);
      } else {
        setZipCodeOK("ok");
        setZipCodeError("");
        setZipCodeValidated(true);
      }
    }, []);

    const handleZipCode = useCallback(async (e, whichZipCode) => {
      e.currentTarget.maxLength = 9;
      let value = e.currentTarget.value;

      value = value.replace(/\D/g, "");
      value = value.replace(/^(\d{5})(\d{3})/, "$1-$2");

      e.currentTarget.value = value;
      setZipCode(value);

      handleValidationZipCode(value);

    }, [originUf, handleValidationZipCode]);

    return {
      zipCodeOK,
      setZipCodeOK,
      zipCodeError,
      setZipCodeError,
      zipCode,
      setZipCode,
      handleZipCode,
      setZipCodeValidated,
      zipCodeValidated
    };
  };

  const {
    zipCodeOK: zipCodeStartOK,
    setZipCodeOK: setZipCodeStartOK,
    zipCodeError: zipCodeStartError,
    setZipCodeError: setZipCodeStartError,
    zipCode: zipCodeStart,
    handleZipCode: handleZipCodeStart,
    setZipCodeValidated: setZipCodeStartValidated,
    zipCodeValidated: zipCodeStartValidated
  } = useZipCode();

  const {
    zipCodeOK: zipCodeEndOK,
    setZipCodeOK: setZipCodeEndOK,
    zipCodeError: zipCodeEndError,
    setZipCodeError: setZipCodeEndError,
    zipCode: zipCodeEnd,
    handleZipCode: handleZipCodeEnd,
    setZipCodeValidated: setZipCodeEndValidated,
    zipCodeValidated: zipCodeEndValidated
  } = useZipCode();

  const useZipCodeDestination = (initialState = "vazio") => {
    const [zipCodeDestinationOK, setZipCodeDestinationOK] = useState(initialState);
    const [zipCodeDestinationError, setZipCodeDestinationError] = useState("");
    const [zipCodeDestination, setZipCodeDestination] = useState("");
    const [zipCodeDestinationValidated, setZipCodeDestinationValidated] = useState(false);

    const handleValidationZipCodeDestination = useCallback((value) => {
      if (value.length === 0) {
        setZipCodeDestinationOK("notOk");
        setZipCodeDestinationError("Preenchimento obrigatório");
        setZipCodeDestinationValidated(false);
      } else if (value.length < 9) {
        setZipCodeDestinationOK("notOk");
        setZipCodeDestinationError("Preenchimento incorreto");
        setZipCodeDestinationValidated(false);
      } else {
        setZipCodeDestinationOK("ok");
        setZipCodeDestinationError("");
        setZipCodeDestinationValidated(true);
      }
    }, []);

    const handleZipCodeDestination = useCallback(async (e, whichZipCode) => {
      e.currentTarget.maxLength = 9;
      let value = e.currentTarget.value;

      value = value.replace(/\D/g, "");
      value = value.replace(/^(\d{5})(\d{3})/, "$1-$2");

      e.currentTarget.value = value;
      setZipCodeDestination(value);

      handleValidationZipCodeDestination(value);

    }, [destinationUf, handleValidationZipCodeDestination]);

    return {
      zipCodeDestinationOK,
      setZipCodeDestinationOK,
      zipCodeDestinationError,
      setZipCodeDestinationError,
      zipCodeDestination,
      setZipCodeDestination,
      handleZipCodeDestination,
      setZipCodeDestinationValidated,
      zipCodeDestinationValidated
    };
  };

  const {
    zipCodeDestinationOK: zipCodeDestinationStartOK,
    setZipCodeDestinationOK: setZipCodeDestinationStartOK,
    zipCodeDestinationError: zipCodeDestinationStartError,
    setZipCodeDestinationError: setZipCodeDestinationStartError,
    zipCodeDestination: zipCodeDestinationStart,
    handleZipCodeDestination: handleZipCodeDestinationStart,
    setZipCodeDestinationValidated: setZipCodeDestinationStartValidated,
    zipCodeDestinationValidated: zipCodeDestinationStartValidated
  } = useZipCodeDestination();

  const {
    zipCodeDestinationOK: zipCodeDestinationEndOK,
    setZipCodeDestinationOK: setZipCodeDestinationEndOK,
    zipCodeDestinationError: zipCodeDestinationEndError,
    setZipCodeDestinationError: setZipCodeDestinationEndError,
    zipCodeDestination: zipCodeDestinationEnd,
    handleZipCodeDestination: handleZipCodeDestinationEnd,
    setZipCodeDestinationValidated: setZipCodeDestinationEndValidated,
    zipCodeDestinationValidated: zipCodeDestinationEndValidated
  } = useZipCodeDestination();

  const handleZipCodeValidationMessage = (whichZipCode, errorMessage) => {
    if (errorMessage && errorMessage.length > 0) {
      if (whichZipCode === "start") {
        setZipCodeStartOK("notOk")
        setZipCodeStartError(errorMessage)
        setZipCodeStartValidated(false)
      } else if (whichZipCode === "end") {
        setZipCodeEndOK("notOk")
        setZipCodeEndError(errorMessage)
        setZipCodeEndValidated(false)
      }
    } else {
      if (whichZipCode === "start") {
        setZipCodeStartValidated(true)
        setZipCodeStartOK("ok")
        setZipCodeStartError("")
      } else if (whichZipCode === "end") {
        setZipCodeEndValidated(true)
        setZipCodeEndOK("ok")
        setZipCodeEndError("")
      }
    }
  }
  const handleZipCodeDestinationValidationMessage = (whichZipCode, errorMessage) => {
    if (errorMessage && errorMessage.length > 0) {
      if (whichZipCode === "start") {
        setZipCodeDestinationStartOK("notOk")
        setZipCodeDestinationStartError(errorMessage)
        setZipCodeDestinationStartValidated(false)
      } else if (whichZipCode === "end") {
        setZipCodeDestinationEndOK("notOk")
        setZipCodeDestinationEndError(errorMessage)
        setZipCodeDestinationEndValidated(false)
      }
    } else {
      if (whichZipCode === "start") {
        setZipCodeDestinationStartValidated(true)
        setZipCodeDestinationStartOK("ok")
        setZipCodeDestinationStartError("")
      } else if (whichZipCode === "end") {
        setZipCodeDestinationEndValidated(true)
        setZipCodeDestinationEndOK("ok")
        setZipCodeDestinationEndError("")
      }
    }
  }

  const formatZipCode = (value) => {
    return value.replace('-', '');
  }

  const handleFormSubmit = useCallback(
    async e => {
      e.preventDefault();

      const formatZipCodeStart = formatZipCode(zipCodeStart);
      const formatZipCodeEnd = formatZipCode(zipCodeEnd);
      let data = {
        zipStart: formatZipCodeStart,
        zipEnd: formatZipCodeEnd,
        sla: Number(sla),
        uf: rateUf.value
      };

      if (!zipCodeStartValidated || !zipCodeEndValidated) {
        Swal.fire("Atenção", "Verifique o preenchimento dos CEPs.", "warning");
        return;
      }

      try {
        if (selectedType.value !== 1) {
          if (!zipCodeDestinationStartValidated || !zipCodeDestinationEndValidated || !originUf.value || !destinationUf.value) {
            Swal.fire("Atenção", "Preencha todos os campos de origem e destino.", "warning");
            return;
          }

          data = {
            code: selectedType?.value,
            originStart: formatZipCodeStart,
            originEnd: formatZipCodeEnd,
            originUf: originUf?.value,
            destinationStart: formatZipCode(zipCodeDestinationStart),
            destinationEnd: formatZipCode(zipCodeDestinationEnd),
            destinationUf: destinationUf?.value,
          };

          setLoading(true);
          await api.makeHttpRequest({ method: "POST", url: '/zipcode-ranges', data });
        } else {
          if (!sla || sla === "" || !rateUf.value) {
            setSlaError(!sla ? "Campo obrigatório" : "");
            setRateUfError(!rateUf.value ? "Campo obrigatório" : "");
            return;
          }

          setLoading(true);
          await api.makeHttpRequest({ method: "POST", url: '/rates', data });
        }

        setModalMessage("Faixa de CEP criada com sucesso");
        setModalTitle("Sucesso!");
        setOpenSuccessModal(true);
      } catch (error) {
        let text = `Ocorreu um erro ao criar faixa de CEP`;
        if (error.response?.data?.message) text = error.response.data.message;
        setModalMessage(text);
        setModalTitle("Erro!");
        setOpenErrorModal(true);
      } finally {
        setLoading(false);
      }
    },
    [zipCodeStart, zipCodeEnd, sla, rateUf.value, zipCodeStartValidated, zipCodeEndValidated, selectedType.value, zipCodeDestinationStartValidated, zipCodeDestinationEndValidated, originUf.value, destinationUf.value, zipCodeDestinationStart, zipCodeDestinationEnd, api]
  );

  const handleSelectedType = useCallback((value) => {
    setSelectedType(value);
  }, [])


  useEffect(() => {
    if (user.profile !== "admin") {
      history.push("/");
    }
  }, []);

  useEffect(() => {
    if (selectedType.value !== 1) {
      if (zipCodeStart
        && zipCodeStartValidated
        && zipCodeEnd
        && zipCodeEndValidated
        && zipCodeDestinationStart
        && zipCodeDestinationStartValidated
        && zipCodeDestinationEnd
        && zipCodeDestinationEndValidated
      ) {
        setButtonStyle(undefined)
      } else {
        setButtonStyle({ cursor: 'not-allowed' })
      }
    } else {
      if (zipCodeStart && zipCodeStartValidated
        && zipCodeEnd && zipCodeEndValidated && sla !== "" && rateUf?.value) {
        setButtonStyle(undefined)
      } else {
        setButtonStyle({ cursor: 'not-allowed' })
      }
    }
  }, [
    selectedType,
    zipCodeStart,
    zipCodeEnd,
    zipCodeStartValidated,
    zipCodeEndValidated,
    zipCodeDestinationStart,
    zipCodeDestinationEnd,
    zipCodeDestinationStartValidated,
    zipCodeDestinationEndValidated,
    sla,
    rateUf
  ])

  return (
    <>
      <Loading isLoading={loading} />
      <MessageModal
        isOpen={openSuccessModal}
        setIsOpen={setOpenSuccessModal}
        icon={<FaCheckCircle style={{ fontSize: "34px", color: "#409E6A" }} />}
        title={modalTitle}
        text={modalMessage}
        buttonStyle={{ color: "#FFF", backgroundColor: "#409E6A" }}
        onButtonClick={() => {
          history.push("/gestao-ceps");
          setOpenSuccessModal(false)
        }}
        onClose={() => {
          history.push("/gestao-ceps");
          setOpenSuccessModal(false)
        }}
      />

      <MessageModal
        isOpen={openErrorModal}
        setIsOpen={setOpenErrorModal}
        icon={<MdOutlineError style={{ fontSize: "34px", color: "#CA1818" }} />}
        buttonStyle={{ color: "#FFF", backgroundColor: "#CA1818" }}
        title={modalTitle}
        text={modalMessage}
        onClose={() => setOpenErrorModal(false)}
      />

      <Container title="Criar faixa de CEP">
        <form className={styles.form} onSubmit={handleFormSubmit}>
          <section className={styles.formContent}>
            <Select
              onChange={(e) => handleSelectedType(e)}
              options={typesOptions}
              value={selectedType}
              placeholder="Selecione o tipo"
              styles={selectStyle}
            />
            {selectedType.value === 1
              ?
              <>
              <div className={styles.row}>
                <div className={styles.inputContainer}>
                  <div
                    className={styles.input}
                    role={zipCodeStartOK}
                  >
                    <input
                      type="text"
                      name="zipCodeStart"
                      placeholder="CEP Inicial"
                      value={zipCodeStart}
                      onChange={e => handleZipCodeStart(e, 'start')}
                    />
                    <AiOutlineCheck className={styles.check} role={zipCodeStartOK} />
                    <BsExclamation className={styles.danger} role={zipCodeStartOK} />
                  </div>
                  {zipCodeStartError && <p className={styles.error}>{zipCodeStartError}</p>}
                </div>
                <div className={styles.inputContainer}>
                  <div
                    className={styles.input}
                    role={zipCodeEndOK}
                  >
                    <input
                      type="text"
                      name="zipCodeEnd"
                      placeholder="CEP Final"
                      value={zipCodeEnd}
                      onChange={e => handleZipCodeEnd(e, 'end')}
                    />
                    <AiOutlineCheck className={styles.check} role={zipCodeEndOK} />
                    <BsExclamation className={styles.danger} role={zipCodeEndOK} />
                  </div>
                  {zipCodeEndError && <p className={styles.error}>{zipCodeEndError}</p>}
                </div>
              </div>
              <div className={styles.row}>
                  <div className={styles.inputContainer}>
                    <div className={styles.input} role={slaError ? "notOk" : "ok"}>
                      <input
                        type="number"
                        name="sla"
                        placeholder="Prazo (SLA em dias)"
                        value={sla}
                        onChange={(e) => {
                          setSla(e.target.value);
                          setSlaError("");
                        }}
                      />
                      {slaError && <BsExclamation className={styles.danger} role="notOk" />}
                    </div>
                    {slaError && <p className={styles.error}>{slaError}</p>}
                  </div>
                  
                  <div className={styles.inputContainer}>
                    <Select
                      onChange={(e) => {
                        setRateUf(e);
                        setRateUfError("");
                      }}
                      options={ufsOptions}
                      value={rateUf}
                      placeholder="UF de destino"
                      styles={selectStyle}
                    />
                    {rateUfError && <p className={styles.error}>{rateUfError}</p>}
                  </div>
                </div>
              </>
              :
              <>
                <div className={styles.row}>
                  <Select
                    onChange={(e) => setOriginUf(e)}
                    options={ufsOptions}
                    value={originUf}
                    placeholder="UF de origem"
                    styles={selectStyle}
                    isDisabled={true}
                  />
                  <div className={styles.inputContainer}>
                    <div
                      className={styles.input}
                      role={zipCodeStartOK}
                    >
                      <input
                        type="text"
                        name="zipCodeStart"
                        placeholder="CEP Inicial"
                        value={zipCodeStart}
                        onChange={e => handleZipCodeStart(e, 'start')}
                      />
                      <AiOutlineCheck className={styles.check} role={zipCodeStartOK} />
                      <BsExclamation className={styles.danger} role={zipCodeStartOK} />
                    </div>
                    {zipCodeStartError && <p className={styles.error}>{zipCodeStartError}</p>}
                  </div>
                  <div className={styles.inputContainer}>
                    <div
                      className={styles.input}
                      role={zipCodeEndOK}
                    >
                      <input
                        type="text"
                        name="zipCodeEnd"
                        placeholder="CEP Final"
                        value={zipCodeEnd}
                        onChange={e => handleZipCodeEnd(e, 'end')}
                      />
                      <AiOutlineCheck className={styles.check} role={zipCodeEndOK} />
                      <BsExclamation className={styles.danger} role={zipCodeEndOK} />
                    </div>
                    {zipCodeEndError && <p className={styles.error}>{zipCodeEndError}</p>}
                  </div>
                </div>
                <div className={styles.row}>
                  <Select
                    onChange={(e) => setDestinationUf(e)}
                    options={ufsOptions}
                    value={destinationUf}
                    placeholder="UF de destino"
                    styles={selectStyle}
                    isDisabled={true}
                  />
                  <div className={styles.inputContainer}>
                    <div
                      className={styles.input}
                      role={zipCodeDestinationStartOK}
                    >
                      <input
                        type="text"
                        name="zipCodeDestinationStart"
                        placeholder="CEP Inicial"
                        value={zipCodeDestinationStart}
                        onChange={e => handleZipCodeDestinationStart(e, 'start')}
                      />
                      <AiOutlineCheck className={styles.check} role={zipCodeDestinationStartOK} />
                      <BsExclamation className={styles.danger} role={zipCodeDestinationStartOK} />
                    </div>
                    {zipCodeDestinationStartError && <p className={styles.error}>{zipCodeDestinationStartError}</p>}
                  </div>
                  <div className={styles.inputContainer}>
                    <div
                      className={styles.input}
                      role={zipCodeDestinationEndOK}
                    >
                      <input
                        type="text"
                        name="zipCodeDestinationEnd"
                        placeholder="CEP Final"
                        value={zipCodeDestinationEnd}
                        onChange={e => handleZipCodeDestinationEnd(e, 'end')}
                      />
                      <AiOutlineCheck className={styles.check} role={zipCodeDestinationEndOK} />
                      <BsExclamation className={styles.danger} role={zipCodeDestinationEndOK} />
                    </div>
                    {zipCodeDestinationEndError && <p className={styles.error}>{zipCodeDestinationEndError}</p>}
                  </div>
                </div>
              </>

            }
          </section>
          <div className={styles.buttonContainer}>
            <button
              type="button"
              onClick={() => history.push("/gestao-ceps")}
              className={styles.buttonBack}
            >
              Voltar
            </button>
            <button type="submit" 
            style={buttonStyle}
            disabled={!!buttonStyle}
            >
              Salvar
            </button>
          </div>
        </form>
      </Container>
    </>
  )
}

export { CreateZipcodeRange }
